import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ColorNeutralWhite, Spacing28 } from 'autogen/design-tokens/tokens';
import { RegimeDrawerButton } from 'autogen/translation-keys/trans-website-regime';
import { Button } from 'components/Button';
import { GA4Tracking } from 'modules/tracking/GA4';
import useRegimeQuickView from './hooks/useRegimeQuickView';

const StyledButton = styled(Button)`
    position: absolute;
    right: 0;
    bottom: ${Spacing28};
    margin-left: auto;

    &, &:hover, &:active, &:focus {
        background-color: ${ColorNeutralWhite};
    }
`;

function RegimeQuickViewButton() {
    const { t } = useTranslation();
    const [, toggle] = useRegimeQuickView();

    function clickHandler() {
        toggle({ isOpen: true });

        GA4Tracking({
            eventName: 'open_related_products_drawer',
            category: 'ecommerce',
            context: 'product_page'
        });
    }

    return (
        <StyledButton variant="outline" size="sm" onClick={clickHandler}>
            {t(RegimeDrawerButton)}
        </StyledButton>
    );
}

export default RegimeQuickViewButton;
